/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect, JSX } from 'react';
import { prependListener } from 'process';
import { iObligation, iFVSCheckboxAll } from '../../interfaces/interfaces';
import styles from './ExpandableRow.module.scss';
import DownArrow from '../../images/downArrow.svg';

interface iProp {
  obligation: iObligation;
  checkedAllParent: iFVSCheckboxAll[];
  setCheckBox: (value: iFVSCheckboxAll[]) => void;
}

function ExpandableRow({ obligation, checkedAllParent, setCheckBox }: iProp): JSX.Element {
    const [accordionOpen, setAccordionOpen] = useState(false);
    const spanRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>();
    const { Number, OffenceDate, OffenceDesc, AmountDue, OffenceLocation, OffenceTime, Registration } = obligation;
    const iconStyle = !accordionOpen ? styles.iconInitiated : styles.iconClicked;
    const handleWindowSizeChange = () => {
        setAccordionOpen(false);
        setHeight(0);
    };
    const checkCurrentFromParent = checkedAllParent.find((v) => (v.number === obligation.Number));
    const handleCurrentCheckbox = (number: string, isChecked: boolean) => {
      const checkboxUpdate = new Array<iFVSCheckboxAll>();
       checkedAllParent.forEach((v) => {
        if (v.number !== obligation.Number) {
          checkboxUpdate.push({ number: v.number, checked: v.checked });
        } else {
          checkboxUpdate.push({ number: v.number, checked: isChecked });
        }
        });
      setCheckBox(checkboxUpdate);
    };
    useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      if (accordionOpen) setHeight(spanRef.current?.getBoundingClientRect().height);
      else setHeight(0);
      return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
      };
    }, [accordionOpen]);
    const handleExpending = () => {
      setAccordionOpen((prev) => !prev);
    };
  return (
    <div className={styles.offenceDetails}>
      <div className={styles.detailValues}>
        <span className={styles.obligationNumber}>
          <div className={styles.checkBoxContainer}>
            <label className={styles.inputContainer}>
              <input
                type="checkbox"
                id={Number}
                checked={checkCurrentFromParent?.checked}
                onChange={(e) => handleCurrentCheckbox(e.target.id, e.target.checked)}
              />
              <span className={styles.inputBody}>{Number}</span>
              <span className={styles.tickContainer} />
            </label>
          </div>
        </span>
        <span className={styles.secondCol}>{OffenceDate}</span>
        <span className={styles.thirdCol}>{OffenceDesc}</span>
        <span className={styles.fourthCol}>
          $
          {AmountDue}
        </span>
        <span className={styles.fifthCol}>
          <button className={styles.iconButton} type="button" onClick={handleExpending}>
            <img src={DownArrow} className={iconStyle} alt="Expand/Contract the quesiton" />
          </button>
        </span>
      </div>
      <div className={styles.detailTable} style={{ height }}>
        <div ref={spanRef} className={styles.divPadding}>
          <table className={styles.offenceTable}>
            <tbody>
              <tr className={styles.onlyMobileRows}>
                <td>OFFENCE DATE</td>
                <td>{OffenceDate}</td>
              </tr>
              <tr className={styles.onlyMobileRows}>
                <td>OFFENCE DESCRIPTION</td>
                <td>{OffenceDesc}</td>
              </tr>
              <tr className={styles.onlyMobileRows}>
                <td>AMOUNT</td>
                <td>
                  $
                  {AmountDue}
                </td>
              </tr>
              <tr>
                <td>OFFENCE LOCATION</td>
                <td className={styles.uppcaseText}>{OffenceLocation}</td>
              </tr>
              <tr>
                <td>TIME OF OFFENCE</td>
                <td>{OffenceTime}</td>
              </tr>
              <tr>
                <td>VEHICLE REGISTRATION</td>
                <td>{Registration}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ExpandableRow;
